export default __webpack_public_path__ + "static/media/topic1400.5a7b8b2f.png";